import React from 'react';
import { FaEdit } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import CustomModal from '../../Elements/CustomModal';
import { getImageUrl } from '../../../lib/helpers';

function profilePhotoUrl(profile) {
  return getImageUrl(profile?.documents_path || profile?.image_path || null);
}

function SuperuserDetailModal({ active, handleModal, superuser, token, onEdit, onDelete }) {
  if (!active || !superuser) return null;

  const imageUrl = profilePhotoUrl(superuser.profile);

  const displayName = superuser.profile?.first_name && superuser.profile?.last_name
    ? `${superuser.profile.first_name} ${superuser.profile.last_name}`
    : superuser.profile?.name && superuser.profile?.last_name
    ? `${superuser.profile.name} ${superuser.profile.last_name}`
    : superuser.email;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <CustomModal
      active={active}
      handleModal={handleModal}
      title="Datos del Superusuario"
      size="large"
      titleId="superuser-detail-modal-title"
    >
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 border-b border-[var(--wa-border)] pb-4">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={displayName}
              className="w-28 h-28 rounded-full object-cover border-2 border-[var(--wa-border)] shrink-0"
              onError={(e) => {
                e.target.style.display = 'none';
                const sib = e.target.nextElementSibling;
                if (sib) sib.classList.remove('hidden');
                if (sib) sib.classList.add('flex');
              }}
            />
          ) : null}
          <div
            className={`w-28 h-28 rounded-full shrink-0 items-center justify-center text-[var(--wa-brand-foreground)] font-bold text-3xl bg-[rgba(132,204,22,0.35)] border border-[var(--wa-border)] ${imageUrl ? 'hidden' : 'flex'}`}
          >
            {displayName.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-xl sm:text-2xl font-semibold text-[var(--wa-foreground)] break-words">{displayName}</h3>
            <p className="text-[var(--wa-muted-foreground)] break-all">{superuser.email}</p>
            <p className="text-sm text-[var(--wa-muted-foreground)]">
              ID: {superuser.id} &bull; Tipo:
              <span className="ml-1 px-2 py-1 text-xs font-semibold rounded-full bg-lime-100 text-lime-900">
                Superadmin
              </span>
            </p>
          </div>
        </div>

        <div className="border-t border-[var(--wa-border)] pt-4">
          <h4 className="text-base font-semibold text-[var(--wa-foreground)] mb-3">Datos Básicos</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Email</label>
              <p className="text-[var(--wa-foreground)]">{superuser.email || '-'}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Privilegios</label>
              <p className="text-[var(--wa-foreground)]">
                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-lime-100 text-lime-900">
                  {superuser.access_privileges || 'superadmin'}
                </span>
              </p>
            </div>
            <div>
              <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">ID de Usuario</label>
              <p className="text-[var(--wa-foreground)] font-mono text-sm">{superuser.id || '-'}</p>
            </div>
            {superuser.profile?.date_created && (
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Fecha de Creación</label>
                <p className="text-[var(--wa-foreground)]">{formatDate(superuser.profile.date_created)}</p>
              </div>
            )}
          </div>
        </div>

        {superuser.profile ? (
          <div className="border-t border-[var(--wa-border)] pt-4">
            <h4 className="text-base font-semibold text-[var(--wa-foreground)] mb-3">Datos Personales</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Nombre</label>
                <p className="text-[var(--wa-foreground)]">{superuser.profile.first_name || superuser.profile.name || '-'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Apellidos</label>
                <p className="text-[var(--wa-foreground)]">{superuser.profile.last_name || '-'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Teléfono</label>
                <p className="text-[var(--wa-foreground)]">{superuser.profile.phone || '-'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Dirección</label>
                <p className="text-[var(--wa-foreground)]">{superuser.profile.address || '-'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-[var(--wa-muted-foreground)]">Saldo</label>
                <p className="text-[var(--wa-foreground)] font-bold text-lg">
                  €{(
                    superuser.profile?.credit_balance ??
                    superuser.profile?.cash_balance ??
                    0
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        ) : null}

        <div className="border-t border-[var(--wa-border)] pt-4 flex justify-center gap-3 flex-wrap">
          <button
            type="button"
            onClick={() => {
              if (onEdit) {
                onEdit();
                handleModal();
              }
            }}
            className="wa-btn-primary inline-flex items-center gap-2 px-4"
            title="Editar superusuario"
          >
            <FaEdit className="text-xl" />
            <span>Editar</span>
          </button>
          <button
            type="button"
            onClick={() => {
              const confirmMessage = '¿Estás seguro de que quieres eliminar este superusuario?';
              if (window.confirm(confirmMessage)) {
                if (onDelete) {
                  onDelete();
                  handleModal();
                }
              }
            }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-[var(--wa-radius)] font-semibold text-white bg-red-600 hover:bg-red-700"
            title="Eliminar superusuario"
          >
            <FaDeleteLeft className="text-xl" />
            <span>Eliminar</span>
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default SuperuserDetailModal;
